$(document).ready(function () {
  const carousel = $(".csm_testimonials-carousel").owlCarousel({
    loop: true,
    margin: 20,
    nav: false,
    autoplay: true, // Enables autoplay
    autoplayTimeout: 3000, // Sets autoplay interval to 3 seconds
    autoplayHoverPause: true, // Pauses autoplay on hover
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      1000: {
        items: 4,
      },
    },
  });

  $(".owl-prev").click(function () {
    carousel.trigger('prev.owl.carousel');
  });

  $(".owl-next").click(function () {
    carousel.trigger('next.owl.carousel');
  });
   $(".collection").each(function () {
    // Find the inner HTML of the current collection__view-all
    const viewAllHtml = $(this).find(".collection__view-all").html();

    // Append the copied HTML to the current collection__title after the h2 element
    $(this).find(".collection__title h2").after(viewAllHtml);

    // Hide the current collection__view-all element
    $(this).find(".collection__view-all").css("display", "none");
  });
});
